import { Component } from 'react'
import PropTypes from 'prop-types'
import localization from 'utils/localization'

class SignOut extends Component {
  componentDidMount () {
    this.props.signOut()
    this.props.flashSuccess({
      message: localization.auth.signedOutMessage.title,
      description: localization.auth.signedOutMessage.description
    })
    setTimeout(() => { window.location = '/' }, 0)
  }
  render () {
    return null
  }
}

SignOut.propTypes = {
  signOut: PropTypes.func.isRequired,
  flashSuccess: PropTypes.func.isRequired
}

export default SignOut
